export const AllRouteType = {
    dashboard: 'dashboard',
    watch: 'watch',
    ipad: 'ipad',
    macbook: 'macbook',
    airpods: 'airpods',
    accessories: 'accessories',
    banner: 'banner',
    news: 'news',
    advise: 'advise',
    import: 'import',
    importHistory: 'import-history',
    saleRecord: 'sale-record',
    voucher: 'voucher',
    comment: 'binh-luan'
}

export const SORTFILTER = {
    DEFAULT : {
        label: 'Mặc định',
        value: ''
    },
    PRICE_ASC : {
        label: 'Giá tăng dần',
        value: 'price_asc'
    }, 
    PRICE_DESC : {
        label: 'Giá giảm dần',
        value: 'price_desc'
    }
}

export const BANK_INFO = {
    name: 'MB Bank',
    number: 896667898888,
    owner: 'NGUYEN TUAN DUNG'
}

export const TIEN_COC = '0'

export const ROLE = {
    // user: 'user',
    admin: '/admin'
}

export const USER_ROLE = {
    admin: 'admin',
    customer: 'customer'
}

export const ACCOUNT_ROUTE = {
    root: '/account',
    changePassword: 'doi-mat-khau',
    purchaseHistory: 'lich-su-mua-hang',
    addressBook: 'so-dia-chi'
}

export const CAM_KET = [
    "Cam kết chính hãng Apple 100%",
    "Hoàn tiền 200% nếu không chính hãng Apple",
    "Bảo hành 4/6/12 tháng",
    "Ship COD toàn quốc - Kiểm tra hàng trước khi thanh toán",
    // "Giảm giá 10% phụ kiện khi mua kèm theo",
    "Hỗ trợ lên đời, thu cũ đổi mới",
    // "Hỗ trợ quẹt thẻ || Trả góp thẻ tín dụng"
]

export const QUA_TANG = [
    "Dây đeo và dây sạc (Apple Watch) chính hãng",
    "Miếng dán màn hình trị giá 100k",
    "Cáp sạc iPhone & iPad 200k",
    "Vệ sinh máy trọn đời"
]

export const SOCIAL_LINKS = {
    facebook: 'https://www.facebook.com/taoone.vn/', //
    tiktok: 'https://www.tiktok.com/@taoone01', // TODO: replace with your account URL
    mobile: '0343.986.324'
}